import React, { memo } from 'react';
import { useAutoFocusOnDidMount } from 'app/modules/subject';
import {
  Timer,
  VisualNumber,
  TitleContainer,
  Title,
  Description,
  ContentContainer,
  Messages,
  ErrorMessage,
  Media,
  AnswerContainer
} from 'app/pages/Survey/Subject/elements';
import Answer from './Answer';

function TextShort() {
  useAutoFocusOnDidMount();

  return (
    <>
      <Timer />
      <VisualNumber />
      <TitleContainer>
        <Title />
        <Description />
      </TitleContainer>
      <ContentContainer>
        <Messages>
          <ErrorMessage />
        </Messages>
        <Media />
        <AnswerContainer>
          <Answer />
        </AnswerContainer>
      </ContentContainer>
    </>
  );
}

export default memo(TextShort);
